import { NoteDetailFormValue } from '../../../../coaching-note/note-detail-form-value.model';
import { Row } from '../../../../coaching-observation/experimental.grid';

import { extractText } from './functions/html-to-text.function';

export enum ColumnID {
    CREATED_BY = 'created_by',
    DATE = 'date',
    NOTE = 'note',
    ACTION = 'action',
}

export enum TemplateID {
    HEADER = 'header',
    CONTENT = 'content',
}

export interface ColumnContext {
    templateId: TemplateID;
}

export interface RowContext {
    notes: NoteDetailFormValue[];
    createdBy: string;
    lastUpdatedOn?: Date;
    lastUpdatedBy?: string;
    date: Date;
    context: string;
    isExpanded: boolean;
    isFiltered: boolean;
}

export interface CellContext {
    templateId: TemplateID;
}

export function makeRows(
    model: NoteDetailFormValue[],
): Array<Row<RowContext, CellContext>> {
    const height = 45;

    return model.map<Row<RowContext, CellContext>>((e) => {
        const trackingFirstName = e.trackingOriginal?.createdByFirstName ?? '';
        const trackingLastName = e.trackingOriginal?.createdByLastName ?? '';
        const defaultFirstName = e.createdByFirstName ?? '';
        const defaultLastName = e.createdByLastName ?? '';

        const createdBy =
            trackingFirstName.length > 0 && trackingLastName.length > 0
                ? `${trackingFirstName} ${trackingLastName}`
                : `${defaultFirstName} ${defaultLastName}`;

        const updatedFirstName = e.trackingOriginal?.updatedByFirstName ?? '';
        const updatedLastName = e.trackingOriginal?.updatedByLastName ?? '';

        const lastUpdatedBy = `${updatedFirstName} ${updatedLastName}`.trim();

        return {
            id: e.trackingId.toString(),
            height,
            ctx: {
                notes: [{ ...e, inEditMode: true }],
                createdBy,
                date:
                    e.trackingOriginal != null
                        ? e.trackingOriginal.createdOn
                        : new Date(),
                context: extractText(e.contents),
                lastUpdatedOn: e.trackingOriginal?.updatedOn,
                lastUpdatedBy,
                isExpanded: e.noteId == null,
                isFiltered: false,
            },
            cells: [
                {
                    columnId: ColumnID.CREATED_BY,
                    height,
                    ctx: { templateId: TemplateID.CONTENT },
                },
                {
                    columnId: ColumnID.DATE,
                    height,
                    ctx: { templateId: TemplateID.CONTENT },
                },
                {
                    columnId: ColumnID.NOTE,
                    height,
                    ctx: { templateId: TemplateID.CONTENT },
                },
                {
                    columnId: ColumnID.ACTION,
                    height,
                    ctx: { templateId: TemplateID.CONTENT },
                },
            ],
        };
    });
}
